import { MutationOptions, useMutation, useQueryClient } from "react-query";
import { APIError, APIResponse, API_URL, post } from "../api";
import { useAuth } from "../context/AuthContext";
import { CREDIT_LIMIT_ELIGIBILITY_STATUS_KEY } from "./useCreditLimitEligibilityStatus";

export interface ClaimCreditLimitResult {
  loan_id: string;
  reference: string;
  loan_amount: number;
  status: string;
}

export function useClaimCreditLimit(
  options?: MutationOptions<APIResponse<ClaimCreditLimitResult>, APIError, void>
) {
  const queryClient = useQueryClient();
  const { user } = useAuth();
  const userId = user?.id;

  const {
    isLoading: claiming,
    isError: isClaimError,
    error: claimError,
    mutate: claimCreditLimit,
    mutateAsync: claimCreditLimitAsync,
    data: claimData,
  } = useMutation<APIResponse<ClaimCreditLimitResult>, APIError, void>(
    async () =>
      (await post(
        API_URL + "/account/user/eligibility/claim",
        {},
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      )) as APIResponse<ClaimCreditLimitResult>,
    {
      ...options,
      onSuccess: async (data, variables, context) => {
        if (userId) {
          await queryClient.invalidateQueries([
            CREDIT_LIMIT_ELIGIBILITY_STATUS_KEY,
            userId,
          ]);
        }
        await queryClient.invalidateQueries("quick-loans");
        options?.onSuccess?.(data, variables, context);
      },
    }
  );

  return {
    claimCreditLimit,
    claimCreditLimitAsync,
    claiming,
    isClaimError,
    claimError,
    claimData,
  };
}

export default useClaimCreditLimit;
